module.exports = __webpack_public_path__ + "static/media/news.acc0c60d.svg";